import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoader: false,
  diagnosisLength: 0,
  diagnosis: [],
  diagnosisError: "",
  formError: "",
}

export default function diagnosisReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_DIAGNOSIS:
      return {...state, loading: action.payload}
    case actions.SAVE_LOADER_DIAGNOSIS:
      return {...state, saveLoader: action.payload}
    case actions.GET_DIAGNOSIS:
      return {...state, diagnosis: action.payload.diagnosis, diagnosisLength: action.payload.diagnosisLength}
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.DIAGNOSIS_FAIL:
      return { ...state, diagnosisError: action.payload };
    default:
      return {...state};
  }
}